export default {
  baseURL: process.env.VUE_APP_BASE_URL,
  activeUsers: "/rt/activeUsers",
  downloads: "/rt/downloads",
  avgSessionDuration: "/rt/sessionDuration",
  paidUsers: "/rt/paidUsers",

  chartDownloads: "/daily/downloads",
  chartActiveUsers: "/daily/activeUsers",
};
